
import React from 'react';
import { useTranslation } from '../hooks/useTranslation';
import { LegalModalType } from '../types';

const XMarkIcon: React.FC<{ className?: string }> = ({ className }) => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className={className}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
    </svg>
);

interface LegalModalProps {
  modalType: LegalModalType;
  onClose: () => void;
}

const LegalModal: React.FC<LegalModalProps> = ({ modalType, onClose }) => {
  const { t } = useTranslation();

  const titleKey = `legal_title_${modalType}` as const;
  const contentKey = `legal_content_${modalType}` as const;
  
  const title = t(titleKey);
  const content = t(contentKey);


  return (
    <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4" onClick={onClose}>
      <div
        className="w-full max-w-3xl bg-white dark:bg-slate-800 rounded-xl shadow-2xl flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between p-6 border-b dark:border-slate-700">
          <h2 className="text-2xl font-bold font-serif text-brand-dark dark:text-white">{title}</h2>
          <button onClick={onClose} className="text-slate-500 hover:text-slate-800 dark:text-slate-400 dark:hover:text-white">
            <XMarkIcon className="w-6 h-6" />
          </button>
        </div>

        <div className="p-8 overflow-y-auto" style={{maxHeight: '70vh'}}>
             <div className="prose dark:prose-invert max-w-none text-slate-600 dark:text-slate-300" dangerouslySetInnerHTML={{ __html: content }} />
        </div>

        <div className="p-4 bg-slate-50 dark:bg-slate-800/50 border-t dark:border-slate-700 flex justify-end">
            <button
                onClick={onClose}
                className="px-6 py-2 text-sm font-medium text-slate-700 bg-slate-100 border border-transparent rounded-lg hover:bg-slate-200 dark:bg-slate-700 dark:text-slate-200 dark:hover:bg-slate-600"
            >
                {t('close_btn')}
            </button>
        </div>
      </div>
       <style>{`
        .prose h3 {
          @apply text-xl font-bold font-serif text-brand-dark dark:text-white mb-2;
        }
        .prose p {
           @apply mb-4;
        }
      `}</style>
    </div>
  );
};

export default LegalModal;
